import React from "react";

export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-10 md:py-16 border-y border-ink/10 bg-bone-2/60 ${className}`}
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {doubled.map((it, i) => (
          <span
            key={i}
            className="font-display text-[14vw] md:text-[10vw] leading-[0.9] tracking-tight text-ink/8 select-none"
            style={{ color: "rgba(10,10,10,0.08)" }}
          >
            <em className="not-italic mr-16">{it}</em>
            <span className="mr-16 text-oxred/25">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
